'use strict';
const React = require('react');

class TableContentComponent extends React.Component {


}

module.exports = TableContentComponent;